import React from 'react'
import { Alert } from 'components'

const ExistAssessmentAlert = (props) => {
    const { accept, close } = props

    const footerActions = React.useMemo(
        () => [
            { label: "ביטול", color: "thirdly4", action: close },
            { label: "יציאה ומחיקה", color: "error", action: accept }
        ], []
    )

    return (
        <Alert
            systemUI
            type="danger"
            title={"האם את בטוחה שאת רוצה לצאת מהאבחון?"}
            footerActions={footerActions}
            handleAlert={close}
        >
            {"יציאה מהאבחון תגרום לאפוס האבחון."}
        </Alert>
    )
}

export default ExistAssessmentAlert